import { useEffect, useState } from 'react';
import {useNavigate} from "react-router-dom";

const useCognitoSessionCheck = (userPool, link_from, intervalMs = 60000) => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkSession = async () => {
      let isSessionExpired = false;
      let currentUser= userPool.getCurrentUser();
      if (currentUser) {
        currentUser.getSession((err, session) => {
          if (err) {
            console.error('Error retrieving session:', err);
            return;
          }
          const currentTime = Math.floor(new Date().getTime() / 1000)
          if (currentTime - session.getAccessToken().payload.auth_time >= 3600) {
            isSessionExpired = true;
          } else {
            isSessionExpired = false;
          }
        });
      } else {
        isSessionExpired = false;
      }
      if (isSessionExpired) navigate('/login', {state: {from: "fast"}})
    };

    checkSession();

    const intervalId = setInterval(checkSession, intervalMs);

    return () => clearInterval(intervalId);
  }, [intervalMs]);
};

export default useCognitoSessionCheck;
